import { Dialog, Zoom } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Timeline } from 'antd';
import { Eye, EyeOff } from "lucide-react";
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FileUploader } from "react-drag-drop-files";
import Draggable from 'react-draggable';
import ReactTimePicker from 'react-time-picker';
import { CartesianGrid, Legend, Line, LineChart, Tooltip, XAxis, YAxis } from 'recharts';
import { FetchAutoCompleteData } from './CustomHooks';
import { CommonApiData, autoCompleteDelay } from './EnvConfig';
import { GetSession } from './criptoUtils';

export const FormButton = (props) => {
    const {
        handleSubmit,
        handleExport,
        handleClear,
        handleSearch,
        handleApprove,
        handleReject,
        handleGenerate,
        id = null,
        search = false,
        searchText = 'Search',
        inputrefs,
        children,
        save = true,
        Export = true,
        update = false,
        Reset = true,
        Reject = false,
        Generate = false,
        saveicon = null,
        Approve = false,
        savetext = 'Save'
    } = props;

    const baseBtn = `
        inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold
        rounded-lg shadow-sm transition-all duration-200
        focus:outline-none focus:ring-1 focus:ring-offset-2
    `;

    const btnRef = useRef();

    const handleMouseMove = (e) => {
        const rect = btnRef?.current?.getBoundingClientRect();
        const x = e?.clientX - rect?.left;
        const y = e?.clientY - rect?.top;

        btnRef?.current?.style?.setProperty("--mouse-x", `${x}px`);
        btnRef?.current?.style?.setProperty("--mouse-y", `${y}px`);
    };

    return (
        <div className="block md:flex gap-2 flex-wrap mt-3">
            {search && (
                <button
                    type="button"
                    name={id}
                    onClick={handleSearch}
                    ref={(ref) => inputrefs && (inputrefs.current[id] = ref)}
                    className={`${baseBtn} bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500`}
                >
                    <i className="fa fa-search"></i>
                    {searchText}
                </button>
            )}

            {save && (
                <>
                    <button
                        onMouseMove={handleMouseMove}
                        name={id}
                        onClick={handleSubmit}
                        ref={(ref) => {
                            btnRef.current = ref;
                            if (inputrefs) inputrefs.current[id] = ref;
                        }}
                        className="ripple-btn px-4 py-2 bg-gradient-to-r from-green-400 via-green-500 to-green-600 text-white rounded font-medium shadow-md uppercase tracking-wide text-sm hover:from-green-500 hover:via-green-600 hover:to-green-700 transition-all hover:shadow-lg duration-300 ease-in-out"
                    >
                        {saveicon ? <i className={saveicon}></i> : <i className="fa">&#xf0c7;</i>}  {savetext}
                    </button>
                </>
            )}

            {update && (
                <button
                    onMouseMove={handleMouseMove}
                    type="button"
                    ref={btnRef}
                    name={id}
                    onClick={handleSubmit}
                    className="ripple-btn px-4 py-2 bg-gradient-to-r from-green-400 via-green-500 to-green-600 text-white rounded font-medium shadow-md uppercase tracking-wide text-sm hover:from-green-500 hover:via-green-600 hover:to-green-700 transition-all hover:shadow-lg duration-300 ease-in-out"
                >
                    <i className="fa fa-upload"></i>
                    Update
                </button>
            )}

            {Export && (
                <button
                    onMouseMove={handleMouseMove}
                    type="button"
                    ref={btnRef}
                    name={id}
                    onClick={handleExport}
                    className="ripple-btn px-4 py-2 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 text-white rounded font-medium shadow-md uppercase tracking-wide text-sm hover:from-yellow-500 hover:via-yellow-600 hover:to-yellow-700 transition-all hover:shadow-lg duration-300 ease-in-out"
                >
                    <i className="fa fa-download"></i> {"Export"}
                </button>
            )}

            {Reset && (
                <button
                    onMouseMove={handleMouseMove}
                    type="button"
                    ref={btnRef}
                    name={id}
                    onClick={handleClear}
                    className="ripple-btn px-4 py-2 bg-gradient-to-r from-red-400 via-red-500 to-red-600 text-white rounded font-medium shadow-md uppercase tracking-wide text-sm hover:from-red-500 hover:via-red-600 hover:to-red-700 transition-all hover:shadow-lg duration-300 ease-in-out"
                >
                    <i className="fa-solid fa-arrow-rotate-left"></i> {"Reset"}

                </button>
            )}

            {Approve && (
                <button
                    onMouseMove={handleMouseMove}
                    type="button"
                    ref={btnRef}
                    name={id}
                    onClick={handleApprove}
                    className="ripple-btn px-4 py-2 bg-gradient-to-r from-green-400 via-green-500 to-green-600 text-white rounded font-medium shadow-md uppercase tracking-wide text-sm hover:from-green-500 hover:via-green-600 hover:to-green-700 transition-all hover:shadow-lg duration-300 ease-in-out"
                >
                    <i class="fa-solid fa-check"></i> {"Approve"}

                </button>
            )}

            {Reject && (
                <button
                    onMouseMove={handleMouseMove}
                    type="button"
                    ref={btnRef}
                    name={id}
                    onClick={handleReject}
                    className="ripple-btn px-4 py-2 bg-gradient-to-r from-red-400 via-red-500 to-red-600 text-white rounded font-medium shadow-md uppercase tracking-wide text-sm hover:from-red-500 hover:via-red-600 hover:to-red-700 transition-all hover:shadow-lg duration-300 ease-in-out"
                >
                    <i className="fa-solid fa-arrow-rotate-left"></i> {"Reject"}

                </button>
            )}
            {Generate && (
                <button
                    onMouseMove={handleMouseMove}
                    type="button"
                    ref={btnRef}
                    name={id}
                    onClick={handleGenerate}
                    className="ripple-btn px-4 py-2 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 text-white rounded font-medium shadow-md uppercase tracking-wide text-sm hover:from-yellow-500 hover:via-yellow-600 hover:to-yellow-700 transition-all hover:shadow-lg duration-300 ease-in-out"
                >
                    <i class="fa fa-cog" aria-hidden="true"></i> {"Generate MIF"}

                </button>
            )}

            {children}
        </div>
    );
};


export const ImportButton = ({ BulkSubmit, handleBulk, downloadFormat, children, Status = [], ErrorData, fileName = '',
    extraElement = false,
    setIsBulkEditDelete, isBulkEditDelete, isAdd = true, isUpdate = true, isDelete = true }) => {

    return (
        <div className="w-full bg-white border border-gray-200 rounded-xl px-4 py-3 shadow-sm">

            {/* Label */}
            <label className="text-gray-800 font-medium mb-2 block">
                Bulk Upload <span className="text-red-500">*</span>
            </label>

            {/* Radio Buttons */}
            {extraElement && (
                <div className="grid grid-cols-3 items-center gap-6 mb-2 text-sm text-gray-700">
                    {isAdd && <label className="flex items-center gap-2 cursor-pointer">

                        <input
                            type="radio"
                            name="isbulkEditUpdate"
                            value="insert"
                            checked={isBulkEditDelete === "insert"}
                            onChange={(e) => setIsBulkEditDelete(e.target.value)}
                            className="text-blueled focus:ring-blueled"
                        />
                        Add
                    </label>
                    }
                    {isUpdate && <label className="flex items-center gap-2 cursor-pointer">
                        <input
                            type="radio"
                            name="isbulkEditUpdate"
                            value="update"
                            checked={isBulkEditDelete === "update"}
                            onChange={(e) => setIsBulkEditDelete(e.target.value)}
                            className="text-blueled focus:ring-blueled"
                        />
                        Update
                    </label>}

                    {isDelete && <label className="flex items-center gap-2 cursor-pointer">
                        <input
                            type="radio"
                            name="isbulkEditUpdate"
                            value="delete"
                            checked={isBulkEditDelete === "delete"}
                            onChange={(e) => setIsBulkEditDelete(e.target.value)}
                            className="text-blueled focus:ring-blueled"
                        />
                        Delete
                    </label>}
                </div>
            )}

            {/* Drop Zone */}
            <FileUploader
                classes="w-full"
                handleChange={BulkSubmit}
                types={["xlsx"]}
                children={
                    <div className="flex items-center justify-center gap-2 w-full py-4 border-2 border-dashed border-blueled rounded-lg cursor-pointer 
                hover:bg-teal-50 transition-all duration-200">
                        <i className="fa fa-upload text-blueled"></i>
                        <span className="text-gray-700">
                            {fileName ? fileName : "Upload Excel File (.xlsx)"}
                        </span>
                    </div>
                }
            />

            {/* Action Buttons */}
            <div className="grid grid-cols-2 items-center gap-4 mt-4">
                <button
                    type="button"
                    className="px-2 py-2 bg-blueled text-white text-sm rounded-md hover:bg-blueled transition-all shadow-sm"
                    onClick={handleBulk}
                >
                    <i className="fa fa-upload ml-1"></i> Upload
                </button>
                <span
                    className="text-blueled ml-2 text-sm underline cursor-pointer hover:text-blueled"
                    onClick={downloadFormat}
                >
                    Download Format <i className="fa fa-download ml-1"></i>
                </span>
            </div>

            {/* Status Display */}
            {Status?.SuccessCount >= 0 && (
                <div className="mt-4 text-sm font-medium flex items-center gap-6">
                    <span className="text-green-600">
                        Success : {Status?.SuccessCount}
                    </span>

                    <span className="text-red-500 flex items-center gap-1">
                        Error : {Status?.ErrorCount}
                        {Status?.ErrorCount > 0 && (
                            <i
                                className="fa fa-download cursor-pointer"
                                onClick={ErrorData}
                            ></i>
                        )}
                    </span>
                </div>
            )}

            {children}
        </div>

    )
}

export const InputBox = (props) => {
    let {
        divclassname = "col-md-3 cntrl-width",
        renderinput = null,
        key = "",
        labelclass = "",
        onKeyDown = null,
        inputclassname = "form-control",
        type = "text",
        divstyle = null,
        inputstyle = null,
        inputrefs,
        id,
        label = "",
        value,
        onChange,
        placeholder,
        required,
        extraElement,
        isPasswordField = false,
        showPassword = false,
        togglePassword = () => { }
    } = props;

    return (
        <div className={`${divclassname} mb-3 relative`} style={divstyle} key={key}>
            {label !== "" && (
                <label
                    style={{ whiteSpace: "nowrap" }}
                    className={`${labelclass} block text-sm font-medium text-gray-700 mb-1`}
                    htmlFor={id}
                >
                    {label}
                    {required && <span style={{ color: "red" }}> *</span>}
                    {extraElement}
                </label>
            )}

            <input
                id={id}
                style={inputstyle}
                onKeyDown={onKeyDown}
                ref={(ref) => (inputrefs.current[id] = ref)}
                type={isPasswordField ? (showPassword ? "text" : "password") : type}
                className={`${inputclassname} block w-full border border-gray-300  focus:ring-1 focus:ring-blueled focus:border-transparent transition duration-200 outline-none`}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                autoComplete="off"
                title={required ? "Please fill this field." : ""}
                {...props}
            />

            {/* Password Toggle Icon */}
            {isPasswordField && (
                <span
                    className="absolute right-5 top-[34px] cursor-pointer text-gray-500"
                    onClick={togglePassword}
                >
                    {showPassword ? (
                        <EyeOff size={18} className="text-[#3C768E]" />
                    ) : (
                        <Eye size={18} className="text-[#3C768E]" />
                    )}
                </span>
            )}

            {renderinput}
        </div>
    );
};

export const InputGroupBox = (props) => {
    const {
        divclassname = "col-md-3  cntrl-width",
        name, id, maxLength, inputstyle,
        disabled, onKeyDown, onChange, onClick,
        pattern, type = "text", value, placeholder,
        label, required, startBoxClass = "",
        startIcon, startText, handleStartButtonClick,
        endBoxClass = "", endIcon, endText,
        handleEndButtonClick, inputrefs
    } = props;

    return (
        <div className={`Input_Group ${divclassname} mb-3`}>

            {/* Label */}
            {label && (
                <label
                    htmlFor={id}
                    className="block text-sm font-medium text-gray-700 mb-0 whitespace-nowrap"
                    title={label}
                >
                    {label}
                    {required && <span className="text-red-600"> *</span>}
                </label>
            )}

            <div className="relative flex items-center rounded-md border border-gray-300 bg-white focus-within:ring-1 focus-within:ring-blueled focus-within:border-transparent transition duration-200">

                {/* Start Icon / Text */}
                {(startIcon || startText) && (
                    <div
                        onClick={handleStartButtonClick}
                        className={`px-2 py-2 text-gray-600 cursor-pointer select-none border-r border-gray-300 bg-gray-100 hover:bg-gray-200 transition rounded-l-md ${startBoxClass}`}
                    >
                        {startIcon && <i className={`${startIcon} text-sm`} />}
                        {startText && <span className="text-sm">{startText}</span>}
                    </div>
                )}

                {/* Input Field */}
                <input
                    onClick={onClick}
                    className="block w-full px-3 py-[7px] text-sm text-gray-700 focus:outline-none"
                    name={name}
                    id={id}
                    ref={(ref) => (inputrefs.current[id] = ref)}
                    maxLength={maxLength}
                    style={inputstyle}
                    disabled={disabled}
                    onKeyDown={onKeyDown}
                    onChange={onChange}
                    pattern={pattern}
                    type={type}
                    value={value}
                    placeholder={placeholder}
                    autoComplete="off"
                />

                {(endIcon || endText) && (
                    <div
                        onClick={handleEndButtonClick}
                        className={`px-2 py-2 text-gray-600 cursor-pointer select-none border-l border-gray-300 bg-gray-100 hover:bg-gray-200 transition rounded-r-md ${endBoxClass}`}
                    >
                        {endIcon && <i className={`${endIcon} text-sm mx-1`} />}
                        {endText && <span className="text-sm">{endText}</span>}
                    </div>
                )}
            </div>
        </div>
    );
};

export const AutoCompleteBoxNew = (props) => {
    const { divclassname = 'col-md-3 cntrl-width', onKeyDown, style, divstyle, inputstyle, inputrefs, maxLength, label = '', nextFocus = ''
        , placeholder, required, value, autocompleteType = '', contextKey = '', contextKey2 = '', contextKey3 = '', contextKey4 = '', contextKey5 = '', renderinput = null,
        Options, onfocusevent = false, isLocalOption = false, ...restProps } = props;

    const { id, multiple = false } = restProps

    const autoCompleteTimeoutRef = useRef(null);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [inputValue, setInputValue] = useState(value);
    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const commonData = CommonApiData()
    let Data = {
        "authToken": commonData.AuthToken,
        "loginToken": commonData.LoginToken,
        "userCode": commonData.UserCode,
        "loginUserGroupID": commonData.loginUserGroupID,
    };
    const handleAutoCompleteChange = (event, prefix) => {
        if (isLocalOption) {
            setAutoCompleteOptions(Options ? Options : []);
        } else {
            if (autoCompleteTimeoutRef.current) {
                clearTimeout(autoCompleteTimeoutRef.current);
            }
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData(Data, prefix, autocompleteType, contextKey, contextKey2, contextKey3, contextKey4, contextKey5);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay);
        }
    };

    return (
        <div
            className={`${divclassname} mb-3 `}
            style={style || divstyle}
        >
            {label === '' ? '' :
                <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor={id}>
                    {label}
                    {required && <span className="text-red-600"> *</span>}
                </label>
            }
            <Autocomplete
                value={inputValue}
                freeSolo
                className={`${divclassname} block w-full  focus:ring-1 focus:ring-blueled focus:border-transparent transition duration-200 outline-none`}
                multiple={multiple}
                autoComplete
                autoSelect={true}
                autoHighlight={inputValue ? false : true} // auto highlight first option
                selectOnFocus={true} // auto select all input text like jquery select
                includeInputInList
                filterOptions={(x) => x} // for accepting every input like (.)
                options={autoCompleteOptions}
                isOptionEqualToValue={(option, value) => multiple && option === value} // auto select option when set value from state
                onInputChange={
                    (event, newInputValue, reason) => {
                        if (reason && newInputValue && reason === 'input') {
                            handleAutoCompleteChange(event, newInputValue);
                        }
                        else {
                            if (autoCompleteOptions) {
                                setAutoCompleteOptions([]);
                            }
                        }
                    }}
                onClose={(event, reason) => {
                    if (autoCompleteOptions) {
                        setAutoCompleteOptions([]);
                    }
                }}
                onOpen={(event) => {
                    if (onfocusevent) {
                        handleAutoCompleteChange(event, '.');
                    }
                }}
                openOnFocus={true}
                title={required ? 'Please fill this field.' : ''}
                renderInput={(params) => <TextField
                    {...params}
                    onInput={(e) => {
                        const { value } = e.target;
                        if (value.length > maxLength) {
                            e.target.value = value.slice(0, maxLength);
                        }
                    }}
                    inputRef={ref => (inputrefs.current[id] = ref)}

                    FormHelperTextProps={{
                        sx: { marginLeft: 0 },
                    }}
                    placeholder={placeholder}
                    onKeyDown={onKeyDown}
                    autoComplete="off"
                />}
                {...restProps}
            />
            {renderinput}
        </div>
    )
}

export const AutoCompleteBoxNumeric = (props) => {
    const { divclassname = 'col-md-3 mb-1 cntrl-width', onKeyDown, style, divstyle, inputstyle, inputrefs, maxLength, label = '', nextFocus = ''
        , placeholder, required, value, autocompleteType = '', contextKey = '', contextKey2 = '', contextKey3 = '', contextKey4 = '', contextKey5 = '', renderinput = null,
        Options, onfocusevent = false, isLocalOption = false, ...restProps } = props;

    const { id, multiple = false } = restProps

    const autoCompleteTimeoutRef = useRef(null);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [inputValue, setInputValue] = useState(value);
    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const commonData = CommonApiData()
    let Data = {
        "authToken": commonData.AuthToken,
        "loginToken": commonData.LoginToken,
        "userCode": commonData.UserCode,
        "userGroupID": commonData.loginUserGroupID,
    };
    const handleAutoCompleteChange = (event, prefix) => {
        if (isLocalOption) {
            setAutoCompleteOptions(Options ? Options : []);
        } else {
            if (autoCompleteTimeoutRef.current) {
                clearTimeout(autoCompleteTimeoutRef.current);
            }
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData(Data, prefix, autocompleteType, contextKey, contextKey2, contextKey3, contextKey4, contextKey5);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay);
        }
    };

    return (
        <div
            className={`${divclassname}`}
            style={style || divstyle}
        >
            {label === '' ? '' :
                <label className="form-label mb-0" htmlFor={id}>{label || ''}
                    {required ? <span style={{ color: "red" }}> *</span> : <></>}
                </label>
            }
            <Autocomplete
                value={inputValue}
                freeSolo
                multiple={multiple}
                autoComplete
                autoSelect
                autoHighlight={inputValue ? false : true}
                selectOnFocus={true}
                includeInputInList
                filterOptions={(x) => x}
                options={autoCompleteOptions}
                isOptionEqualToValue={(option, value) => multiple && option === value}
                onInputChange={
                    (event, newInputValue, reason) => {
                        if (reason && newInputValue && reason === 'input') {
                            handleAutoCompleteChange(event, newInputValue);
                        }
                        else {
                            if (autoCompleteOptions) {
                                setAutoCompleteOptions([]);
                            }
                        }
                    }}
                onClose={(event, reason) => {
                    if (autoCompleteOptions) {
                        setAutoCompleteOptions([]);

                    }
                }}
                onOpen={(event) => {
                    if (onfocusevent) {
                        handleAutoCompleteChange(event, '.');
                    }
                }}
                openOnFocus={true}
                title={required ? 'Please fill this field.' : ''}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        onInput={(e) => {
                            const { value } = e.target;
                            const numericValue = value.replace(/[^0-9]/g, '');
                            if (value !== numericValue) {
                                e.target.value = numericValue;
                            }
                            if (numericValue.length > maxLength) {
                                e.target.value = numericValue.slice(0, maxLength);
                            }
                        }}
                        inputRef={(ref) => (inputrefs.current[id] = ref)}
                        sx={inputstyle}
                        placeholder={placeholder}
                        onKeyDown={onKeyDown}
                        autoComplete="off"
                    />
                )}

                {...restProps}
            />
            {renderinput}
        </div>
    )
}

export const DateBox = (props) => {
    const {
        divclassname = "w-full md:w-1/4 mb-3",
        datepikerclass = "",
        labelstyle,
        style,
        inputstyle,
        label = "",
        onKeyDown,
        selected,
        placeholder,
        id,
        minDate,
        maxDate,
        inputrefs,
        onChange,
        required,
        extraElement
    } = props;

    const validDateInput = function (e) {
        e.target.value = "";
    };

    return (
        <div className={`${divclassname} mb-3 relative`} style={style}>
            {label && (
                <label
                    className="block text-sm font-medium text-gray-700 mb-1"
                    style={labelstyle}
                >
                    {label}
                    {required && <span className="text-red-600"> *</span>}
                    {extraElement && extraElement}
                </label>
            )}

            <DatePicker
                className={`block w-full border border-gray-300 rounded-md px-3 py-2 text-sm
                            focus:ring-1 focus:ring-blueled focus:border-transparent
                            transition duration-200 outline-none ${datepikerclass}`}
                style={inputstyle}
                dateFormat="dd-MMM-yyyy"
                placeholderText={placeholder}
                selected={selected}
                ref={(ref) => (inputrefs.current[id] = ref?.input)}
                onKeyDown={onKeyDown}
                showYearDropdown
                maxDate={maxDate}
                minDate={minDate}
                showMonthDropdown
                yearDropdownItemNumber={100}
                scrollableYearDropdown
                preventOpenOnFocus={true}
                onChange={onChange}
                onChangeRaw={(e) => validDateInput(e)}
                autoComplete="off"
                title={required ? "Please fill this field." : ""}
                {...props}
            />
        </div>
    );
};

export const SelectInputBox = (props) => {
    const { divclassname = 'col-md-3 cntrl-width', inputclassname = '', onKeyDown, divstyle, inputstyle, inputrefs, id, label = '', value = '', onChange, children, required = false } = props
    return (
        <div
            className={` ${divclassname} mb-3 `}
            style={divstyle}
        >
            {label === '' ? '' :
                <label className="block text-sm font-medium text-gray-700 mb-1" htmlFor={id}>{label || 'Branch'}
                    {required ? <span style={{ color: "red" }}> *</span> : <></>}
                </label>}
            <select
                id={id}
                className={`form-select block w-full border border-gray-300  focus:ring-1 focus:ring-blueled focus:border-transparent transition duration-200 outline-none ${inputclassname}`}
                style={inputstyle}
                onKeyDown={onKeyDown}
                ref={ref => (inputrefs.current[id] = ref)}
                value={value}
                onChange={onChange}
                title={required ? 'Please select an item in the list.' : ''}
                autoComplete="off"
                {...props}
            >
                {children}
            </select>
        </div>
    )
}

export const Switch = (props) => {
    const {
        id,
        checked = false,
        inputrefs,
        onKeyDown,
        label,
        lableClassName = 'block text-sm font-medium text-gray-700 ',
        onChange,
        divclassname = 'col-md-3  cntrl-width',
        ...rest
    } = props;

    return (
        <div className={`${divclassname}`} key={`checkin${id}`}>
            <label className="flex items-center gap-2 cursor-pointer select-none mt-1">

                <input
                    type="checkbox"
                    id={id}
                    checked={checked}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    ref={(ref) => (inputrefs.current[id] = ref)}
                    className="sr-only peer"
                    autoComplete="off"
                    {...rest}
                />

                <div className="
                    w-10 h-5 bg-gray-300 rounded-full relative
                    peer-focus:ring-1 peer-focus:ring-blueled
                    peer-checked:bg-blueled transition-all duration-200
                "></div>

                <div
                    className="
                        absolute w-3 h-3 bg-white rounded-full shadow
                        transition-transform duration-200 pointer-events-none
                        peer-checked:translate-x-5 ml-1 
                    "
                ></div>

                {/* Label */}
                <span className={lableClassName}>{label}</span>
            </label>
        </div>
    );
};

export const RadioButton = (props) => {
    const { id, name, value, checked = false, inputrefs, onKeyDown, label, onChange, extraclassname = 'form-check form-radio ps-4 mt-3 me-2', lableClassName = 'form-check-label ms-2', divclassname = 'col-md-3 mb-1 cntrl-width' } = props;
    return (
        <div className={`${divclassname}`} key={`radio${id}`}>
            <div className={`${extraclassname}`}>
                <input
                    className="form-check-input"
                    type="radio"
                    id={id}
                    name={name}
                    value={value}
                    checked={checked}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    ref={ref => (inputrefs?.current && (inputrefs.current[id] = ref))}
                    {...props}
                />
                <label className={`${lableClassName}`} htmlFor={id}>{label}</label>
            </div>
        </div>
    )
}

export const CheckBoxInput = (props) => {
    const { id, checked = false, maindivclassname = 'col-md-4 col-lg-3 col-6 mb-1 cntrl-width', divclassname = `form-check form-switch ps-4 ps-md-5 mt-3`, labelclassname = "form-check-label ms-2", inputrefs, onKeyDown, label = '', onChange } = props
    return (
        <div className={maindivclassname} key={`checkin${id}`}>
            <div className={divclassname}>
                <input
                    className=""
                    type="checkbox"
                    id={id}
                    checked={checked}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    ref={ref => (inputrefs.current[id] = ref)}
                    {...props}
                />
                {label !== '' && <label className={labelclassname} htmlFor={id}>{label}</label>}
            </div>
        </div>
    )
}

export const MessageBoxAlert = React.memo(({ Msg = '', clearMessage, Status, uniqueId }) => {
    const audio = useMemo(() => new Audio(Status !== 'SUCCESS' ? './Sound/Error.mp3' : './Sound/Success.mp3'), [Status]);

    const handleClearMessage = useCallback(() => {
        clearMessage();
    }, [clearMessage]);
    let enableNotificationSound = false;
    if (GetSession('localStorage', 'enableNotificationSound') === 'true') {
        enableNotificationSound = true;
    }
    else if (GetSession('localStorage', 'enableNotificationSound') === null) {
        enableNotificationSound = true;
    }
    if (Msg !== '' && uniqueId) {
        if (enableNotificationSound) {

            audio.play();
        }
    }

    return (
        <>
            {Msg === '' ? '' :
                <div className='container-fluid p-0 m-0 pt-1 '>
                    <div className='col-md-12 col-lg-12 col-12 px-3 py-2 rounded' style={{ background: Status !== 'SUCCESS' ? '#ff7070' : '#68d95b96', color: '#172b64', fontWeight: '500' }}>
                        {Msg}
                        <span style={{ float: 'right', cursor: 'pointer' }} onClick={handleClearMessage}>X</span>
                    </div>
                </div>
            }
        </>
    );
});

export const TimeBox = (props) => {
    let { divclassname = 'col-md-3 mb-1 cntrl-width ', key = '', hideclock = true, labelclass = 'form-label', inputstyle, onKeyDown = null, inputclassname = '', divstyle = null, inputrefs, id, label = '', value, onChange, placeholder, required } = props

    const findFirstEnabledVisibleInput = (parent) => {
        if (!parent) return null;
        const isVisible = (elem) => !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
        const inputs = parent.querySelectorAll('input');
        for (let input of inputs) {
            if (!input.disabled && isVisible(input)) {
                return input;
            }
        }
        return null;
    };

    return (
        <div
            className={`${divclassname}`}
            style={divstyle}
        >
            {label !== '' ? <label style={{ 'whiteSpace': 'nowrap' }} className={labelclass} htmlFor={id}>{label}
                {required ? <span style={{ color: "red" }}> *</span> : <></>}
            </label> : <></>}
            <div
                ref={ref => {
                    const firstEnabledVisibleInput = findFirstEnabledVisibleInput(ref);
                    inputrefs.current[id] = firstEnabledVisibleInput;
                }}
                className='TimeBox'
                key={key}
            >
                <ReactTimePicker
                    value={value}
                    style={inputstyle}
                    onChange={onChange}
                    format="HH:mm"
                    clockIcon=''
                    placeholder={placeholder}
                    disableClock={hideclock}
                    autoComplete="off"
                    title={required ? 'Please fill this field.' : ''}
                    id={id}
                    onKeyDown={onKeyDown}
                    className={`form-control ${inputclassname}`}
                    {...props}
                />

            </div>
        </div>
    )
}

export const DragComponent = (paperProps) => (
    <Draggable
        handle="#alert-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
    >
        <div
            {...paperProps}
            style={{
                backgroundColor: 'white',
                boxShadow: 'none',
                minWidth: '400px',
                ...paperProps.style
            }}
        />
    </Draggable>
);

export const LineChartComponent = ({ Data = [], onClickHandler, width, height, showLegend = true }) => {
    let displayData = Data && Data.length > 0 ? Data.map(item => ({
        ...item,
        amount: Number(item.amount),
    })) : [];
    return <LineChart
        width={width} height={height}
        data={displayData}
        margin={{
            top: 15,
            right: 25,
            left: 0,
            bottom: 15,
        }}
        onClick={onClickHandler}
    >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
            dataKey="title"
            tick={{ fontSize: 14 }}
            interval={0}
            angle={-25}
            textAnchor="end"
        />
        <YAxis tick={{ fontSize: 8 }} />
        <Tooltip />
        {showLegend && <Legend />}
        <Line dataKey="amount" stroke="#82ca9d" />
    </LineChart>
}

export const MovementHistory = (props) => {
    const { movementHistoryData, height = "40vh", handleCloseMenuList, closeIconShow = false } = props;
    var data = [];
    for (let i = 0; i < movementHistoryData.length; i++) {
        data.push({
            label: (
                <p>
                    {(movementHistoryData[i]?.statusDate)?.split(' ')[0]}
                    <br />
                    <i className="text-secondary">{(movementHistoryData[i]?.statusDate)?.split(' ')[1]}</i>
                </p>
            ),
            children: (
                <p>
                    <h6 className='m-0 p-0'>{movementHistoryData[i]?.packetStatus}</h6>
                    <span>{movementHistoryData[i]?.statusDetails}</span>
                    <br />
                    {movementHistoryData[i]?.podLocation && <i className="text-success">{movementHistoryData[i]?.podLocation}</i>}
                </p>
            ),
        });
    }
    return (
        movementHistoryData?.length > 0 && <div className='col-12 mx-0 border'>
            <div className="">
                <div className='card-header border-bottom d-flex justify-content-between w-100' style={{ padding: '0px 0px', backgroundColor: 'gray', color: '#fff' }}>
                    <p className="py-1 px-2" style={{ fontFamily: 'sans-serif', fontWeight: 500, lineHeight: 1.1, color: '#fff', marginBottom: '0px' }} >{"Tracking History"}</p>
                    {closeIconShow &&
                        <i
                            className="fa fa-times close-icon"
                            onClick={handleCloseMenuList}
                            title="Close"
                            style={{ cursor: 'pointer', padding: "8px" }}
                        ></i>
                    }
                </div>
            </div>
            <div mode="alternate" style={{ paddingTop: "20px", backgroundColor: "var(--main-card)", height: height, overflowY: "auto", overflowX: "hidden" }}>
                <Timeline
                    mode='left'
                    items={data}
                />
            </div>
        </div>
    )
}

export const TextareaBox = (props) => {
    let toUpperCase = GetSession('cookies', 'isUpperCase');
    const { divclassname = "col-lg-4 col-md-6 col-sm-12 ", rows, name, zoom, inputrefs, onChange, label, error, onClick, id, divstyle, maxLength, value, required, inputstyle, onKeyDown, onFocus, InfoDetails, onBlur, pattern, type = "text", inputclassname, placeholder, disabled } = props;
    const [zoomIn, setZoomIn] = useState(false);

    const handleZoomIn = async () => {
        await setZoomIn(true);
    }
    const handleZoomOut = async () => {
        await setZoomIn(false);
    }
    return (
        <div className={`fields ${divclassname} ${zoom && "position-relative"}`} style={divstyle}>
            {label !== "" && label && <label className={`block text-sm font-medium text-gray-700 mb-1 ${error && value?.trim() === "" && "text-error-color"}`} title={label}>{label}{required && <span className="text-danger">*</span>}</label>
            }
            <textarea
                rows={rows}
                className={`form-control focus:ring-1 focus:ring-blueled focus:border-transparent transition duration-200 outline-none  ${inputclassname} ${error && value?.trim() === "" && "border-error-color"}`}
                id={id}
                name={name}
                maxLength={maxLength}
                style={inputstyle}
                disabled={disabled}
                ref={ref => (inputrefs.current[id] = ref)}
                onKeyDown={onKeyDown}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                onClick={onClick}
                pattern={pattern}
                type={type ? type : "text"}
                value={toUpperCase && typeof value === 'string' ? value.toUpperCase() : value || ''}
                placeholder={placeholder}
                autoComplete="off"
            />
            {zoom && (zoomIn ? <i className="fa-solid fa-compress arrow zoom-icon-placement" onClick={() => handleZoomOut()}></i> :
                <i className="fas fa-expand arrow zoom-icon-placement" onClick={() => handleZoomIn()}></i>
            )}
            {error && value?.trim() === "" && <div className="error-msg">{error}</div>}

            {zoomIn &&
                <Dialog
                    open={zoomIn}
                    onClose={handleZoomOut}
                    keepMounted
                    maxWidth="md"
                    fullWidth
                    TransitionComponent={Zoom}
                    TransitionProps={{ timeout: { enter: 1000, exit: 500 } }}
                >

                    <textarea
                        rows={rows}
                        className={`form-control ${inputclassname} ${error && value?.trim() === "" && "border-error-color"}`}
                        id={id}
                        name={name}
                        maxLength={maxLength}
                        style={inputstyle}
                        disabled={disabled}
                        onKeyDown={onKeyDown}
                        onChange={onChange}
                        onFocus={onFocus}
                        onBlur={onBlur}
                        onClick={onClick}
                        pattern={pattern}
                        type={type ? type : "text"}
                        value={value}
                        placeholder={placeholder}
                        autoComplete="off"
                    />
                </Dialog>
            }
        </div>
    )
}

export const CustomCard = (props) => {
    const { children, heading, customPadding, heading_title, headingClassname, addon_heading, boxMainDivClass, boxMainDivStyle, headingBordercolor = '', headBorder = '', boxBorder = false, boxBorderColor = '', headingIcon, borderTopColor,
        borderTop = '0', borderRight = '0', borderLeft = '0', borderBottom = '0', height = "auto", ref, rest, openBox, setOpenBox, toggleOpenBox = false
    } = props

    return (
        <div className={`${customPadding} ${boxMainDivClass} `} style={boxMainDivStyle} ref={ref} {...rest}>
            <div className="main-card rounded-2" style={boxBorder ? { borderTop: borderTopColor && `2px solid ${borderTopColor}`, borderWidth: `${borderTop}px ${borderRight}px ${borderBottom}px ${borderLeft}px`, borderStyle: "solid", borderColor: boxBorderColor || headingBordercolor } : { borderTop: borderTopColor && `2px solid ${borderTopColor}` }}>
                {heading && <div onClick={toggleOpenBox ? (() => setOpenBox(!openBox)) : undefined}
                    className={`headingstyle heading_textsize position-relative ${headingClassname} ${addon_heading ?
                        "d-lg-flex d-md-flex d-sm-flex gap-2" :
                        ""} `}
                    style={toggleOpenBox ? { background: "var(--bg-light)", cursor: "pointer" } : {}}>
                    <h6 style={heading_title && headingBordercolor ? {
                        display: "inline",
                        background: headingBordercolor,
                        borderRadius: "7px 24px 24px 7px",
                        padding: "1px 15px",
                        position: "relative",
                        left: "-20px",
                        top: "-8px"
                    } : { display: "inline" }}>{headingIcon && <i className={headingIcon} style={{ zIndex: "100000" }}></i>}{heading_title}</h6>{addon_heading && addon_heading}
                    {toggleOpenBox && <div className='box_toggle_button' ><i onClick={() => setOpenBox(!openBox)} className={openBox ? 'fa-solid fa-chevron-up arrow p-1' : 'fa-solid fa-chevron-down arrow p-1'}></i></div>}

                </div>
                }
                {toggleOpenBox ?
                    <div className={`${openBox ? 'collapse show pb-2' : 'collapsed'}`} style={openBox ? { height: height, transition: 'all ease-in 0.6s', } : { height: '0px', transition: 'all ease-in 0.6s' }}>
                        {openBox && children}
                    </div>
                    :
                    <div className={`pb-3`} style={{ height: height, transition: 'all ease-in 0.6s', }}>
                        {children}
                    </div>
                }

            </div>
        </div>
    )
};
